<script setup lang="ts">
  defineProps<{
    tokenPath: string;
    examplePath: string;
  }>();

  const EMPTY_MESSAGE =
    'Nenhuma rota configurada. Selecione um campo de data na 1ª Rota para montar o caminho.';
</script>

<template>
  <div class="flex flex-col gap-4" data-testid="archiving-preview">
    <div class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-gray-07">Caminho do arquivamento:</span>
      <div
        role="status"
        aria-live="polite"
        class="flex min-h-12 items-center rounded-lg border border-gray-02 bg-gray-02/20 px-5 py-3 text-sm"
      >
        <code
          v-if="tokenPath"
          class="break-all font-mono text-gray-07"
          data-testid="archiving-token-path"
          >{{ tokenPath }}</code
        >
        <span v-else class="text-gray-05" data-testid="archiving-preview-empty">
          {{ EMPTY_MESSAGE }}
        </span>
      </div>
    </div>

    <div v-if="tokenPath" class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-gray-07">Exemplo do arquivamento</span>
      <div
        class="flex min-h-12 items-center rounded-lg border border-gray-02 bg-gray-02/20 px-5 py-3 text-sm"
      >
        <code class="break-all font-mono text-gray-07" data-testid="archiving-example-path">{{
          examplePath
        }}</code>
      </div>
    </div>
  </div>
</template>
